/**
 * @generated SignedSource<<775c2f075754f8fb873f498140f53315>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackItemRecipientSawFeedbackMutation$variables = {
  id: string;
};
export type FeedbackItemRecipientSawFeedbackMutation$data = {
  readonly recipientSawFeedback: {
    readonly feedback: {
      readonly lastSeenByUser: string | null;
    };
  } | null;
};
export type FeedbackItemRecipientSawFeedbackMutation = {
  response: FeedbackItemRecipientSawFeedbackMutation$data;
  variables: FeedbackItemRecipientSawFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenByUser",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackItemRecipientSawFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipientSawFeedback",
        "kind": "LinkedField",
        "name": "recipientSawFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackNode",
            "kind": "LinkedField",
            "name": "feedback",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackItemRecipientSawFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipientSawFeedback",
        "kind": "LinkedField",
        "name": "recipientSawFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackNode",
            "kind": "LinkedField",
            "name": "feedback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bacf719c03d38335b69fa660a5069684",
    "id": null,
    "metadata": {},
    "name": "FeedbackItemRecipientSawFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackItemRecipientSawFeedbackMutation(\n  $id: ID!\n) {\n  recipientSawFeedback(id: $id) {\n    feedback {\n      lastSeenByUser\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3c7b4c83645826f9339b56c1a0ee8d8";

export default node;
